<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <span
          id="saldoBancario"
          :style="styleSaldo(saldoBancario)"
        >
          {{ saldoBancario }}
        </span>
      </div>
    </div>
  </v-container>
</template>

<script>
  import FluxoCaixa from '../../../../../services/fluxocaixa'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowSaldoTotal',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: '#4CAF50',
      },
      styleSaldoBancario: {
        color: '#4CAF50',
      },
      loading: false,
      error: null,
      select: [],
      saldoBancario: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    }),

    created () {
      eventEmit.$on('update-fluxo', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-fluxo', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (select) {
        this.select = select

        this.showSaldo()
      },

      async showSaldo () {
        this.loading = true

        this.saldoBancario = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        await FluxoCaixa.showSaldoBancario(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.saldoBancario = resposta.data.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else {
            this.saldoBancario = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      styleSaldo (value) {
        var negativo = value.substr(0, 1)

        if (negativo === '-') {
          return 'color: #f27686'
        } else {
          return 'color: #4CAF50'
        }
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #saldoBancario {
    font-size: 36px;
    display: grid;
    align-items: center;
    margin: 0.7rem 0 0 8rem;
    font-weight: bold;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #saldoBancario {
      font-size: 22px;
      display: grid;
      align-items: center;
      margin: -2rem 0 0 8rem;
      font-weight: bold;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #saldoBancario {
      font-size: 26px;
      display: grid;
      align-items: center;
      margin:-1rem 0 0 20rem;
      font-weight: bold;
    }
  }
</style>
